import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-row', {
    staticClass: "px-4"
  }, [_vm.certificadoVencidoMsg ? _c('div', {
    staticClass: "card card-custom bg-light-warning card-stretch gutter-b p-4"
  }, [_c('p', {
    staticClass: "mb-0 font-weight-bolder"
  }, [_c('Warning', {
    attrs: {
      "size": 20
    }
  }), _vm._v(" " + _vm._s(_vm.certificadoVencidoMsg) + " "), _c('strong', [_c('a', {
    attrs: {
      "href": "https://wa.me/554935500600?text=Quero saber mais sobre o certificado digital!",
      "target": "_blank"
    }
  }, [_vm._v(" Clique Aqui")])])], 1)]) : _vm._e()]), _c('b-row', {
    staticClass: "px-4 blinking-row"
  }, [_vm.licenca.apresentar_renovacao ? _c('div', {
    staticClass: "card card-custom bg-light-danger card-stretch gutter-b p-4"
  }, [_c('p', {
    staticClass: "mb-0 font-weight-bolder"
  }, [_c('Warning', {
    attrs: {
      "size": 20
    }
  }), _vm._v(" Sua assinatura está prestes a vencer nos próximos dias, realize a sua renovação automaticamente: "), _c('strong', [_c('a', {
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'assinatura'
        });
      }
    }
  }, [_vm._v(" Para realizar a renovação agora, clique aqui! ")])])], 1)]) : _vm._e()]), _vm.useCustomDashboard ? _c('b-row', [_c('div', {
    staticClass: "col-12 d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_vm.visibleDashboardCards.length ? _c('div', {
    staticClass: "custom-dashboard-grid"
  }, [_c('GridLayout', {
    attrs: {
      "layout": _vm.displayDashboardLayout,
      "col-num": _vm.dashboardGridColumns,
      "row-height": _vm.dashboardGridRowHeight,
      "is-draggable": _vm.dashboardEditing,
      "is-resizable": false,
      "vertical-compact": true,
      "prevent-collision": false,
      "margin": _vm.dashboardGridMargin,
      "use-css-transforms": false
    },
    on: {
      "update:layout": _vm.onDashboardGridLayoutUpdate
    }
  }, _vm._l(_vm.displayDashboardLayout, function (layoutItem) {
    return _c('GridItem', {
      key: layoutItem.i,
      attrs: {
        "x": layoutItem.x,
        "y": layoutItem.y,
        "w": layoutItem.w,
        "h": layoutItem.h,
        "i": layoutItem.i
      }
    }, [_c('div', {
      staticClass: "dashboard-grid-card",
      class: {
        'dashboard-grid-card-editing': _vm.dashboardEditing
      }
    }, [_vm.dashboardEditing ? _c('span', {
      staticClass: "dashboard-drag-handle"
    }, [_vm._v(" Mover ")]) : _vm._e(), _c(_vm.getDashboardCard(layoutItem.i).component, _vm._g(_vm._b({
      tag: "component",
      staticClass: "dash-widget h-100"
    }, 'component', _vm.getDashboardCardProps(layoutItem.i), false), _vm.getDashboardCardListeners(layoutItem.i)))], 1)]);
  }), 1)], 1) : _c('div', {
    staticClass: "dashboard-empty-custom"
  }, [_vm._v(" Nenhum card configurado para o seu dashboard. ")])]), _c('div', {
    staticClass: "d-none ml-8 d-lg-block",
    staticStyle: {
      "width": "250px"
    }
  }, [_c('div', {
    staticClass: "dashboard-edit-toolbar mb-4"
  }, [_vm.dashboardEditing ? [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "dashboard-edit-icon",
    attrs: {
      "title": "Salvar layout",
      "variant": "light-primary"
    },
    on: {
      "click": _vm.saveDashboardLayout
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "check2"
    }
  })], 1), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "dashboard-edit-icon",
    attrs: {
      "title": "Cancelar edição",
      "variant": "light"
    },
    on: {
      "click": _vm.cancelDashboardEdit
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x"
    }
  })], 1), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "dashboard-edit-icon",
    attrs: {
      "title": "Restaurar padrão",
      "variant": "light"
    },
    on: {
      "click": _vm.restoreDefaultDashboardLayout
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "arrow-counterclockwise"
    }
  })], 1)] : _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "dashboard-edit-icon",
    attrs: {
      "title": "Editar dashboard",
      "variant": "light"
    },
    on: {
      "click": _vm.startDashboardEdit
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "pencil"
    }
  })], 1)], 2), _c('Atalhos', {
    attrs: {
      "editing": _vm.dashboardEditing
    }
  }), _c('PainelGrupoAtalho', {
    staticClass: "mt-4"
  }), _vm.pacoteNovidades && _vm.isRevendaNuts ? _c('CardNovidades', {
    staticClass: "mt-4",
    attrs: {
      "pacote": _vm.pacoteNovidades
    },
    on: {
      "ver-novidades": _vm.abrirModalNovidades
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "d-block d-lg-none"
  }, [_vm.dashboardEditing ? _c('div', {
    staticClass: "dashboard-edit-toolbar dashboard-edit-toolbar-mobile mb-4"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "dashboard-edit-icon",
    attrs: {
      "title": "Salvar layout",
      "variant": "light-primary"
    },
    on: {
      "click": _vm.saveDashboardLayout
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "check2"
    }
  })], 1), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "dashboard-edit-icon",
    attrs: {
      "title": "Cancelar edição",
      "variant": "light"
    },
    on: {
      "click": _vm.cancelDashboardEdit
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x"
    }
  })], 1), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "dashboard-edit-icon",
    attrs: {
      "title": "Restaurar padrão",
      "variant": "light"
    },
    on: {
      "click": _vm.restoreDefaultDashboardLayout
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "arrow-counterclockwise"
    }
  })], 1)], 1) : _vm._e(), _c('FabAtalhos'), _c('PainelGrupoAtalho', {
    staticClass: "mx-4 mt-4"
  })], 1)])]) : _vm._e(), !_vm.useCustomDashboard ? _c('b-row', [_c('div', {
    staticClass: "col-12 d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('b-row', [_c('div', {
    staticClass: "col-md-4 mb-8"
  }, [_c('Totalizador', {
    staticClass: "dash-widget",
    attrs: {
      "totais-cadastros": _vm.totais_cadastros,
      "loading": _vm.loadingTotais
    }
  })], 1), _vm.userAccessStore.access.financeiro ? _c('div', {
    staticClass: "col-md-8 mb-8"
  }, [_c('TotalizadorContas', {
    staticClass: "dash-widget",
    attrs: {
      "totaisFinanceiros": _vm.totais_financeiros,
      "loading": _vm.loadingTotais
    }
  })], 1) : _vm._e()]), _vm.currentUser.admin ? _c('b-row', [_c('div', {
    staticClass: "col-md-4 mb-8"
  }, [_c('TicketMedio', {
    staticClass: "dash-widget",
    attrs: {
      "ticketMedio": _vm.ticketMedio,
      "loading": _vm.loadingTicketMedio,
      "periodo": _vm.tmPeriodo,
      "ignore-initial-apply": true
    },
    on: {
      "change-periodo": function changePeriodo($event) {
        return _vm.onPeriodoChange('ticketMedio', $event);
      }
    }
  })], 1), _c('div', {
    staticClass: "col-md-4 mb-8"
  }, [_c('MargemLucro', {
    staticClass: "dash-widget",
    attrs: {
      "margemLucro": _vm.margemLucro,
      "periodo": _vm.margemPeriodo,
      "loading": _vm.loadingMargemLucro,
      "ignore-initial-apply": true
    },
    on: {
      "change-periodo": function changePeriodo($event) {
        return _vm.onPeriodoChange('margemLucro', $event);
      }
    }
  })], 1), _c('div', {
    staticClass: "col-md-4 mb-8"
  }, [_c('Vendas', {
    staticClass: "dash-widget",
    attrs: {
      "valorVendas": _vm.valorVendas,
      "periodo": _vm.vendasPeriodo,
      "loading": _vm.loadingValorVendas,
      "ignore-initial-apply": true
    },
    on: {
      "change-periodo": function changePeriodo($event) {
        return _vm.onPeriodoChange('valorVendas', $event);
      }
    }
  })], 1)]) : _vm._e(), _vm.currentUser.admin ? _c('b-row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-row', [_c('div', {
    staticClass: "col-12 mb-8"
  }, [_c('MetaFaturamento', {
    attrs: {
      "loading": _vm.loadingMeta,
      "dados": _vm.metaMensal
    }
  })], 1), _c('div', {
    staticClass: "col-12 mb-8"
  }, [_c('Inadimplencia', {
    staticClass: "dash-widget",
    attrs: {
      "loading": _vm.loadingInadimplencia,
      "inadimplencia": _vm.inadimplencia,
      "periodo": _vm.inadimplenciaPeriodo,
      "ignore-initial-apply": true
    },
    on: {
      "change-periodo": function changePeriodo($event) {
        return _vm.onPeriodoChange('inadimplencia', $event);
      }
    }
  })], 1)])], 1), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-row', [_c('div', {
    staticClass: "col-12 col-xxxl-6 mb-8"
  }, [_c('RelacaoFinanceira', {
    staticClass: "dash-widget",
    attrs: {
      "dados": _vm.relacaoFinanceira,
      "periodo": _vm.relacaoFinanceiraPeriodo,
      "loading": _vm.loadingRelacaoFinanceira,
      "ignore-initial-apply": true
    },
    on: {
      "change-periodo": function changePeriodo($event) {
        return _vm.onPeriodoChange('relacaoFinanceira', $event);
      }
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-xxxl-6 mb-8"
  }, [_c('GraficoVendas', {
    staticClass: "dash-widget",
    attrs: {
      "dados": _vm.relacaoVendas,
      "loading": _vm.loadingGraficoVendas,
      "ignore-initial-apply": true
    },
    on: {
      "change-comparacao": _vm.onComparacaoVendas
    }
  })], 1)])], 1)]) : _vm._e()], 1), _c('div', {
    staticClass: "d-none ml-8 d-lg-block",
    staticStyle: {
      "width": "250px"
    }
  }, [_c('Atalhos'), _c('PainelGrupoAtalho', {
    staticClass: "mt-4"
  }), _vm.pacoteNovidades && _vm.isRevendaNuts ? _c('CardNovidades', {
    staticClass: "mt-4",
    attrs: {
      "pacote": _vm.pacoteNovidades
    },
    on: {
      "ver-novidades": _vm.abrirModalNovidades
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "d-block d-lg-none"
  }, [_c('FabAtalhos'), _c('PainelGrupoAtalho', {
    staticClass: "mx-4 mt-4"
  })], 1)])]) : _vm._e(), _vm.isRevendaNuts ? _c('ModalNovidades', {
    attrs: {
      "modal-id": "modal-novidades-dashboard",
      "pacote": _vm.pacoteNovidades
    },
    on: {
      "lido": _vm.onNovidadeLida,
      "fechar": function fechar($event) {
        _vm.modalNovidadesAberto = false;
      }
    }
  }) : _vm._e(), !_vm.useCustomDashboard ? _c('b-row', [_c('div', {
    staticClass: "col-md-5 col-xxxl-4 mb-8"
  }, [_c('Aniversariantes', {
    staticClass: "dash-widget h-100",
    attrs: {
      "dados": _vm.aniversariantes,
      "loading": _vm.loadingAniversariantes
    }
  })], 1), _vm.currentUser.admin ? _c('div', {
    staticClass: "col-md-6 col-xxxl-4 mb-8"
  }, [_c('TopProdutosVendidos', {
    staticClass: "dash-widget",
    attrs: {
      "dados": _vm.produtosMaisVendidos,
      "periodo": _vm.produtosPeriodo,
      "loading": _vm.loadingTopProdutos,
      "ignore-initial-apply": true
    },
    on: {
      "change-periodo": function changePeriodo($event) {
        return _vm.onPeriodoChange('produtosMaisVendidos', $event);
      }
    }
  })], 1) : _vm._e(), _vm.currentUser.admin ? _c('div', {
    staticClass: "col-md-6 col-xxxl-4 mb-8"
  }, [_c('TopClientes', {
    staticClass: "dash-widget",
    attrs: {
      "dados": _vm.clientesTop,
      "periodo": _vm.clientesPeriodo,
      "loading": _vm.loadingMaioresClientes,
      "ignore-initial-apply": true
    },
    on: {
      "change-periodo": function changePeriodo($event) {
        return _vm.onPeriodoChange('clientesTop', $event);
      }
    }
  })], 1) : _vm._e()]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };